function handleRechargeWidgetLoad(widgetHostElement) {
  console.log("Recharge widget has loaded and its shadowRoot is available!");

  const addToCartButton = document.querySelector(".btn--add-to-cart");

  if (addToCartButton) {
    addToCartButton.removeAttribute("disabled");
    addToCartButton.dataset.rechargeSubscription = true; 
    // console.log("Add to cart button found:", addToCartButton);
   } else {
    console.error("Add to cart button not found within the shadow DOM.");
  }
}
const observer = new MutationObserver((mutationsList, observer) => {
  const widgetHost = document.querySelector("recharge-subscription-widget");
  
  if (widgetHost && widgetHost.shadowRoot) {
    // console.log("widgetHost and shadowRoot found!");
    handleRechargeWidgetLoad(widgetHost);
    observer.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});